import { EditableTextArea } from '@idaho-aeyc/ui-kit';
import { styled } from 'styled-components';

export const SEditableTextArea = styled(EditableTextArea)``;
